import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./routes/PrivateRoute";
import Login from "./pages/login";
import Dashboard from "./pages/dashboard";
import MainLayout from "./layouts/MainLayout";
import Card from "./pages/card";
import Savings from "./pages/savings";
import Loan from "./pages/loan";
import Insurance from "./pages/insurance";
import Apartment from "./pages/apartment";
import Staff from "./pages/staff";
import Settings from "./pages/settings";
import Issuers from "./pages/issuer";
import Categories from "./pages/categories";
import News from "./pages/news";
import NewsDetail from "./pages/news/detail";
import NewsTaxonomies from "./pages/news/taxonomies";
import Banners from "./pages/banners";
import Promotions from "./pages/promotion";
import AuditLog from "./pages/audit";
import Keywords from "./pages/keywords";
import HomeProducts from "./pages/home-products/HomeProducts";
import AboutSections from "./pages/about";

export default function App() {
  useEffect(() => {
    import("bootstrap/dist/js/bootstrap.bundle.min.js");
  }, []);

  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<Login />} />
      {/* Private */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="card" element={<Card />} />
        <Route path="savings" element={<Savings />} />
        <Route path="loan" element={<Loan />} />
        <Route path="insurance" element={<Insurance />} />
        <Route path="apartment" element={<Apartment />} />
        <Route path="staff" element={<Staff />} />
        <Route path="settings" element={<Settings />} />
        <Route path="issuers" element={<Issuers />} />
        <Route path="categories" element={<Categories />} />
        <Route path="news" element={<News />} />
        <Route path="news/:slug" element={<NewsDetail />} />
        <Route path="news-taxonomies" element={<NewsTaxonomies />} />
        <Route path="banners" element={<Banners />} />
        <Route path="promotions" element={<Promotions />} />
        <Route path="audit" element={<AuditLog />} />
        <Route path="keywords" element={<Keywords />} />
        <Route path="home-products" element={<HomeProducts />} />
        <Route path="about-sections" element={<AboutSections />} />
      </Route>
    </Routes>
  );
}
